import { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthLayout, { Field, inputStyle } from './AuthLayout';
import { useZh, useEmailEnabled } from '../lib/useProduct';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const zh = useZh();
  // The server answers 200 whether or not the address exists, so nothing here
  // reveals account existence. Whether the deployment can send mail at all is a
  // different, deployment-wide fact — and when it can't, "check your email"
  // would be a straightforward lie.
  const canEmail = useEmailEnabled();

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    await fetch('/api/forgot-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email.trim() }),
    });
    setDone(true);
    setSubmitting(false);
  }

  const backToSignIn = (
    <Link to="/login" style={{ color: 'var(--pri)' }}>{zh ? '返回登录' : 'Back to sign in'}</Link>
  );

  if (!canEmail) {
    return (
      <AuthLayout
        title={zh ? '暂时无法自助重置密码' : 'Password reset is unavailable'}
        subtitle={
          zh
            ? '本站目前还没有配置邮件发送服务，重置链接发不出来。请直接联系管理员帮你重置，抱歉。'
            : 'This deployment has no email provider configured, so a reset link cannot be delivered. Please contact the operator to reset your password.'
        }
        footer={backToSignIn}
      >
        <div />
      </AuthLayout>
    );
  }

  if (done) {
    return (
      <AuthLayout
        title={zh ? '请查收邮件' : 'Check your email'}
        subtitle={
          zh
            ? '如果该邮箱已注册，我们已经发送了重置链接。链接 1 小时内有效。'
            : "If an account exists for that address, we've sent a password reset link. The link expires in 1 hour."
        }
        footer={backToSignIn}
      >
        <div />
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title={zh ? '重置密码' : 'Reset your password'}
      subtitle={zh ? '填写你的邮箱，我们会发送一次性重置链接。' : "Enter your email and we'll send a one-time reset link."}
      footer={backToSignIn}
    >
      <form onSubmit={onSubmit}>
        <Field label={zh ? '邮箱' : 'Email'}>
          <input type="email" autoFocus required value={email} onChange={(e) => setEmail(e.target.value)} style={inputStyle} />
        </Field>
        <button type="submit" className="btn accent" style={{ width: '100%' }} disabled={submitting || !email}>
          {submitting ? (zh ? '发送中…' : 'Sending…') : (zh ? '发送重置链接' : 'Send reset link')}
        </button>
      </form>
    </AuthLayout>
  );
}
